import { useAuth } from "../../context/AuthContext";

const Navigation = () => {
  const { isAuthenticated, userAttributes, isLoading } = useAuth();
  const fullName = userAttributes?.name || "User";

  if (isLoading) {
    return <div className="navbar_link">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <div className="navbar_link">Not logged in</div>;
  }
  return <div className="navbar_link">{fullName}</div>;
};

export default Navigation;
